import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getStrainData } from '../actions/strainAction';

export interface StrainData {
  strainId: number;
  organisationId: number;
  fullName: string;
  date: Date;
  recovery: number;
  strain: number;
  averageHeartRate: number;
  totalWorkouts: number;
  workoutStrain: number;
  percentageOfDailyStrainFromWorkout: number;
  dailyStrainWithoutWorkout: number;
  sports: Sport[];
  optimalStrain: number;
  shipId: number;
}

interface Sport {
    name: string;
}

export interface StrainState {
  strainData: StrainData[];
  loading: boolean;
  error: string | null;
  searchResults: StrainData[] | undefined;
}

const initialState: StrainState = {
  strainData: [],
  loading: false,
  error: '',
  searchResults: undefined,
};

interface PayloadObject {
  yesterday: String;
  shipId: number;
}

const strainDataSlice = createSlice({
  name: 'strainData',
  initialState: initialState,
  reducers: {
    searchStrain: (state: StrainState, action: PayloadAction<PayloadObject>) => { 
      state.searchResults = action.payload ? state.strainData.filter(
        s => s.date.toString().split("T")[0] == action.payload.yesterday).filter(
          s => s.shipId == action.payload.shipId
        ) : [];
    }
  },
  extraReducers: (builder) => {
    // load strainData
    builder.addCase(getStrainData.pending, (state: StrainState) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getStrainData.fulfilled, (state: StrainState, { payload }: PayloadAction<StrainData[]>) => {
        state.loading = false
        state.strainData = payload
    }),
    builder.addCase(getStrainData.rejected, (state: StrainState, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { searchStrain } = strainDataSlice.actions;

export default strainDataSlice.reducer;